import { createAction, props } from '@ngrx/store';
import { ManageTemplateGridItemModel } from 'src/app/access-control/models/manage-template-grid-item.model';
import {
    AccessControlClientTemplate,
    AccessControlContractCompanyTemplate
} from 'src/app/shared/models/access-control-contract-company-template.model';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import { ListItem } from 'src/app/shared/models/list-item.model';

export const loadCompanyTemplates = createAction('[ACCESS CONTROL MANAGE TEMPLATES COMPONENT] Load Company Templates');

export const loadCompanyTemplatesSuccess = createAction(
    '[ACCESS CONTROL API] Load Company Templates Success',
    props<{ templates: PagingTokenFixed<ManageTemplateGridItemModel[]> }>()
);

export const loadCompanyTemplatesFail = createAction('[ACCESS CONTROL API] Load Company Templates Fail');

export const setManageTemplateFilter = createAction(
    '[ACCESS CONTROL COMPONENT] Set Manage Templates Filter',
    props<{ filter: FetchArgs }>()
);
export const setOnlyMyTemplatesFilter = createAction(
    '[ACCESS CONTROL COMPONENT] Set Only My Template Filter',
    props<{ onlyMyTemplates: boolean }>()
);

export const loadCompanyTypes = createAction('[ACCESS CONTROL MANAGE TEMPLATES COMPONENT] Load Company Types');

export const loadCompanyTypesSuccess = createAction(
    '[ACCESS CONTROL API] Load Company Types Success',
    props<{ companyTypes: ListItem[] }>()
);

export const loadCompanyTypesFail = createAction('[ACCESS CONTROL API] Load Company Types Fail');

export const loadAccessControlContractCompanyTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Load Access Control Contract Company Template',
    props<{ templateId: number }>()
);

export const loadAccessControlContractCompanyTemplateSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Template Success',
    props<{ contractTemplate: AccessControlContractCompanyTemplate }>()
);

export const loadAccessControlContractCompanyTemplateFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Contract Company Template Fail',
    props<{ error: any }>()
);

export const loadAccessControlClientCompanyTemplate = createAction(
    '[ACCESS CONTROL INFORMATION VIEW EDIT COMPONENT] Load Access Control Client Company Template',
    props<{ templateId: number }>()
);

export const loadAccessControlClientCompanyTemplateSuccess = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Company Template Success',
    props<{ clientTemplate: AccessControlClientTemplate }>()
);

export const loadAccessControlClientCompanyTemplateFail = createAction(
    '[ACCESS CONTROL API] Load Access Control Client Company Template Fail',
    props<{ error: any }>()
);

export const deleteCompanyTemplate = createAction(
    '[ACCESS CONTROL MANAGE TEMPLATES COMPONENT] Delete Company Template',
    props<{ templateId: number }>()
);

export const deleteCompanyTemplateSuccess = createAction(
    '[ACCESS CONTROL API] Delete Company Template Success'
);

export const deleteCompanyTemplateFail = createAction(
    '[ACCESS CONTROL API] Delete Company Template Fail'
);
